import {
  Box,
  Grid,
  TextField,
  createTheme,
  ThemeProvider,
  useTheme,
  MenuItem,
  Menu,
  Select,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import MUIDataTable from "mui-datatables";
import MoreHorizTwoToneIcon from "@mui/icons-material/MoreHorizTwoTone";
import EditNoteIcon from "@mui/icons-material/EditNote";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import { LeadSourceSettingsApi } from "../../../Data/axios";
import { ChromePicker } from "react-color";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

function LeaveType() {
  const [open, setOpen] = React.useState(false);
  const [updateLead, setUpdateLead] = React.useState("");
  const [lead, setLead] = React.useState("");
  const [leadSource, setLeadSource] = useState([]);
  const [data, setData] = useState([]);
  const [openMenuId, setOpenMenuId] = useState(null);
  const [update, setUpdate] = React.useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const theme = useTheme();
  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };
  const [updateColor, setUpdateColor] = React.useState("#ff0000");
  const [anchorEl, setAnchorEl] = React.useState(null);

  const [leaveType, setLeaveType] = useState(""); // Leave Type
  const [leaveAllotmentType, setLeaveAllotmentType] = useState("monthly"); // Leave Allotment Type
  const [monthlyLeaves, setMonthlyLeaves] = useState("0"); // No of Monthly Leaves
  const [leavePaidStatus, setLeavePaidStatus] = useState("paid"); // Leave Paid Status
  const [labelColor, setLabelColor] = useState("#000000"); // Label Color
  const [effectiveAfterDays, setEffectiveAfterDays] = useState(""); // Effective After (Days/Months)
  const [effectiveAfterUnit, setEffectiveAfterUnit] = useState("days"); // Effective After Unit (Days/Months)
  const [allowedInProbation, setAllowedInProbation] = useState(false); // Allowed in Probation (Checkbox)
  const [unusedLeaves, setUnusedLeaves] = useState("carry-forward"); // Unused Leaves
  const [overUtilization, setOverUtilization] = useState("do-not-allow"); // Over Utilization
  const [allowedInNoticePeriod, setAllowedInNoticePeriod] = useState(false); // Allowed in Notice Period (Checkbox)
  const [gender, setGender] = useState(["male"]); // Gender (Multi-select Dropdown)
  const [maritalStatus, setMaritalStatus] = useState(["single"]); // Marital Status (Multi-select Dropdown)
  const [department, setDepartment] = useState(["marketing"]); // Department (Multi-select Dropdown)
  const [designation, setDesignation] = useState(["trainee"]); // Designation (Multi-select Dropdown)
  const [role, setRole] = useState(["employee"]); // Role (Multi-select Dropdown)
  const [showColorPicker, setShowColorPicker] = useState(false);

  const openDropMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseAnchor = () => {
    setAnchorEl(null);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const openColor = Boolean(anchorEl);
  const handleClickUpdate = () => {
    setUpdate(true);
  };
  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const handleUpdateClose = () => {
    setUpdate(false);
  };
  
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const response = await LeadSourceSettingsApi.getAll();

    setLeadSource(response?.data);
  }

  const columns = [
    {
      name: "source",
      label: "Leave Type",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Leave Type
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "source",
      label: " Allotment Type",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Allotment Type
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "source",
      label: "No of Leaves",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              No of Leaves
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "source",
      label: "Monthly Limit",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Monthly Limit
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "source",
      label: "Leave Paid Status",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Leave Paid Status
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "source",
      label: "Department",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Department
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "rate",
      label: "Designation",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "center",
                borderBottom: "1px solid #ddd",
              }}
            >
              Designation
            </th>
          );
        },
        customBodyRender: (value) => {
          return (
            <div
              key={value}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {(value || " ").charAt(0).toUpperCase() + (value || " ").slice(1)}
            </div>
          );
        },
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        customHeadRender: ({ index }) => {
          return (
            <th
              key={index}
              style={{
                textAlign: "right",
                paddingRight: "30px",
                borderBottom: "1px solid #ddd",
              }}
            >
              Actions
            </th>
          );
        },
        customBodyRender: (value, tableMeta) => (
          <div
            key={value}
            style={{
              display: "flex",
              justifyContent: "flex-end", // Aligns content to the left
              alignItems: "center",
            }}
          >
            <div>
              <Button
                id="basic-button"
                aria-controls={openDropMenu ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={openDropMenu ? "true" : undefined}
                onClick={handleClick}
              >
                <div onClick={() => handleOpenMenu(value)}>
                  <MoreHorizTwoToneIcon />
                </div>
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={openDropMenu}
                onClose={handleCloseMenu}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem onClick={handleCloseMenu}>
                  <div
                    onClick={() => handleEdit(tableMeta.rowData)}
                    style={{
                      display: "flex",
                      justifyContent: "space-center",
                      alignItems: "center",
                    }}
                  >
                    <EditNoteIcon /> Edit
                  </div>
                </MenuItem>

                <MenuItem onClick={handleCloseMenu}>
                  <div
                    onClick={() => handleDelete(value)}
                    style={{
                      display: "flex",
                      justifyContent: "space-center",
                      alignItems: "center",
                    }}
                  >
                    <DeleteForeverIcon /> Delete
                  </div>
                </MenuItem>
              </Menu>
            </div>
          </div>
        ),
      },
    },
  ];
  async function handleEdit(id) {
    const result = await LeadSourceSettingsApi.edit(id);
    setData(result);

    handleClickUpdate();
  }
  useEffect(() => {
    setUpdateLead(data.source);
  }, [data.source]);

  async function UpdateData() {
    const formData = new FormData();
    formData.append("source", updateLead);
    try {
      await LeadSourceSettingsApi.update(data.id, formData);
      showAlert(" Updated successfully", "success");
      handleUpdateClose();
      getData();
    } catch (error) {
      console.error(error);
      showAlert("Failed to update ", "error");
    }
  }

  async function handleDelete(id) {
    await LeadSourceSettingsApi.delete(id);
    getData();
    showAlert(" Deleted successfully", "warning");
  }

  // Save Lead Sourse

  const item = {
    source: lead,
  };

  async function SaveDate() {
    try {
      const formData = new FormData();

      // Append each item to the FormData object
      for (const key in item) {
        if (item[key] !== undefined && item[key] !== null) {
          formData.append(key, item[key]);
        }
      }
      await LeadSourceSettingsApi.add(formData);
      showAlert("Lead Source Added Successfully!", "success");
      getData();
      setOpen(false);
    } catch (error) {
      console.error("Fetch error:", error);
      showAlert("Failed to add Lead Source", "error");
    }

    // }
  }

  const options = {
    selectableRows: "none",
    selectToolbarPlacement: "none",
    elevation: 0,
    rowsPerPage: 5,
    rowsPerPageOptions: [5, 10, 25, 100],
    tableBody: {
      style: {
        maxHeight: "500px",
        overflowY: "scroll",
        marginLeft: "5PX",
      },
    },
    tableHead: {
      style: {
        backgroundColor: "#f2f2f2",
        color: "black",
      },
    },
    rows: {
      style: {
        marginLeft: "5px",
        textAlign: "center",
      },
      selectableRowsOnClick: true,
    },
  };

  const getTheme = () =>
    createTheme({
      palette: {
        mode: "light",
        primary: {
          main: "#2196f3",
        },
        secondary: {
          main: "#03a9f4",
        },
      },
      typography: {
        fontFamily: ["Roboto", "Helvetica", "Arial", "Sans-serif"].join(","),
      },
      components: {
        MuiButton: {
          styleOverrides: {
            root: {
              textTransform: "none",
            },
          },
        },
      },
      tableBody: {
        style: {
          maxHeight: "500px",
          overflowY: "scroll",
        },
      },
      tableHead: {
        style: {
          backgroundColor: "#f2f2f2",
          color: "black",
        },
      },
      rows: {
        style: {
          "&:hover": {
            backgroundColor: "#f2f2f2",
          },
        },
      },
    });

  return (
    <>
      <List style={{ background: "none", padding: 5 }}>
        <StatusAlert
          open={alertOpen}
          setOpen={setAlertOpen}
          message={alertMessage}
          severity={alertSeverity}
        />
        <ListItemText style={{ background: "none", marginTop: 5 }}>
          <React.Fragment>
            <Box
              onClick={handleClickOpen}
              sx={{
                backgroundColor: "#1d82f5",
                "&:hover": { backgroundColor: "orange" },
                textAlign: "center",
                padding: "10px",

                height: "40px",
                width: "150px",
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                borderRadius: "4px",
                fontSize: "15px",
                fontFamily: "sans-serif",
                cursor: "pointer",
              }}
            >
              <AddCircleIcon /> Add LeaveType
            </Box>
            <Dialog
              fullWidth
              maxWidth="md"
              open={open}
              onClose={handleClose}
              TransitionComponent={Transition}
              PaperProps={{
                style: {
                  position: "absolute",
                  background: "#fff",
                  top: "0",
                  maxHeight: "95%",
                  margin: "auto",
                  overflowX: "hidden",
                  zIndex: 1200,
                },
              }}
            >
              <AppBar sx={{ position: "relative", bgcolor: "#1d82f5" }}>
                <Toolbar>
                  <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                    <CloseIcon fontSize="large" />
                  </IconButton>
                  <Typography sx={{ ml: 2, flex: 1, fontSize: "18px" }} component="div">
                    New Leave Type
                  </Typography>
                </Toolbar>
              </AppBar>
              <Box
                component="form"
                sx={{
                  p: 3,
                  bgcolor: "#fff",
                  borderRadius: 1,
                  boxShadow: 1,
                  overflowY: "auto",
                }}
              >
                <Grid container spacing={3}>
                  {/* Leave Type */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Leave Type
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Eg: Sick, Casual"
                      value={leaveType}
                      onChange={(e) => setLeaveType(e.target.value)}
                      sx={{
                        border: "1px solid gray",
                        borderRadius:"5px",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                        "& .MuiOutlinedInput-input": { color: "black" },
                      }}
                    />
                  </Grid>
                  {/* Leave Allotment Type */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Leave Allotment Type
                    </Typography>
                    <Select
                      fullWidth
                      value={leaveAllotmentType}
                      onChange={(e) => setLeaveAllotmentType(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="monthly">Monthly</MenuItem>
                      <MenuItem value="yearly">Yearly</MenuItem>
                    </Select>
                  </Grid>
                  {/* No of Monthly Leaves */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      No of Monthly Leaves
                    </Typography>
                    <TextField
                      fullWidth
                     
                      value={monthlyLeaves}
                      onChange={(e) => setMonthlyLeaves(e.target.value)}
                      sx={{
                        border: "1px solid gray",
                        borderRadius:"5px",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                        "& .MuiOutlinedInput-input": { color: "black" },
                      }}
                    />
                  </Grid>
                  {/* Leave Paid Status */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Leave Paid Status
                    </Typography>
                    <Select
                      fullWidth
                      value={leavePaidStatus}
                      onChange={(e) => setLeavePaidStatus(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="paid" >Paid</MenuItem>
                      <MenuItem value="unpaid">Unpaid</MenuItem>
                    </Select>
                  </Grid>
                  {/* Label Color */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="p" gutterBottom style={{ color: "black" }}>
                      Label Color
                    </Typography>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Box
                            sx={{
                              width: 40,
                              height: 40,
                              backgroundColor: labelColor,
                              border: "1px solid black",
                              borderRadius: "5px",
                            }}
                          ></Box>
                          <Button
                            variant="outlined"
                            onClick={() => setShowColorPicker(!showColorPicker)}
                            sx={{
                              color: "black",
                              border: "1px solid black",
                            }}
                          >
                            Choose Color
                          </Button>
                        </Box>
                        {showColorPicker && (
                          <ChromePicker
                            color={labelColor}
                            onChangeComplete={(color) => setLabelColor(color.hex)}
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* Effective After Days/Months */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Effective After
                    </Typography>
                    <Box sx={{ display: "flex", gap: 0 }}>
                      <TextField
                       
                        value={effectiveAfterDays}
                        onChange={(e) => setEffectiveAfterDays(e.target.value)}
                        sx={{
                          border: "1px solid gray",
                          borderRadius:"5px 0px 0px 5px",
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": { borderColor: "black" },
                            "&.Mui-focused fieldset": { borderColor: "black" },
                          },
                          "& .MuiSelect-select": { color: "black" },
                          "& .MuiOutlinedInput-input": { color: "black" },
                        }}
                      />
                      <Select
                        value={effectiveAfterUnit}
                        onChange={(e) => setEffectiveAfterUnit(e.target.value)}
                        sx={{
                          border: "1px solid gray",
                          borderRadius:"0px 5px 5px 0px",
                          "& .MuiOutlinedInput-root": {
                            "&:hover fieldset": { borderColor: "black" },
                            "&.Mui-focused fieldset": { borderColor: "black" },
                          },
                          "& .MuiSelect-select": { color: "black" },
                        }}
                      >
                        <MenuItem value="days">Days</MenuItem>
                        <MenuItem value="months">Months</MenuItem>
                      </Select>
                    </Box>
                  </Grid>
                  {/* Allowed in Probation */}
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={allowedInProbation}
                          onChange={(e) => setAllowedInProbation(e.target.checked)}
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 24 },
                            color: "black",
                            "&.Mui-checked": { color: "#2196f3" },
                          }}
                        />
                      }
                      label="Allowed in Probation"
                      sx={{ color: "black" }}
                    />
                  </Grid>
                  {/* Unused Leaves */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Unused Leaves
                    </Typography>
                    <Select
                      fullWidth
                      value={unusedLeaves}
                      onChange={(e) => setUnusedLeaves(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="carry-forward">Carry Forward</MenuItem>
                      <MenuItem value="lapse">Lapse</MenuItem>
                      <MenuItem value="paid">Paid</MenuItem>
                    </Select>
                  </Grid>
                  {/* Over Utilization */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Over Utilization
                    </Typography>
                    <Select
                      fullWidth
                      value={overUtilization}
                      onChange={(e) => setOverUtilization(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="do-not-allow">Do Not Allow</MenuItem>
                      <MenuItem value="allow-mark-paid">Allow and Mark Paid</MenuItem>
                      <MenuItem value="allow-mark-unpaid">Allow and Mark Unpaid</MenuItem>
                    </Select>
                  </Grid>
                  {/* Allowed in Notice Period */}
                  <Grid item xs={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={allowedInNoticePeriod}
                          onChange={(e) => setAllowedInNoticePeriod(e.target.checked)}
                          sx={{
                            "& .MuiSvgIcon-root": { fontSize: 24 },
                            color: "black",
                            "&.Mui-checked": { color: "#2196f3" },
                          }}
                        />
                      }
                      label="Allowed in Notice Period"
                      sx={{ color: "black" }}
                    />
                  </Grid>
                  {/* Gender */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Gender
                    </Typography>
                    <Select
                      fullWidth
                      multiple
                      value={gender}
                      onChange={(e) => setGender(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="male">Male</MenuItem>
                      <MenuItem value="female">Female</MenuItem>
                      <MenuItem value="others">Others</MenuItem>
                    </Select>
                  </Grid>
                  {/* Marital Status */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Marital Status
                    </Typography>
                    <Select
                      fullWidth
                      multiple
                      value={maritalStatus}
                      onChange={(e) => setMaritalStatus(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="single">Single</MenuItem>
                      <MenuItem value="married">Married</MenuItem>
                      <MenuItem value="widow">Widow</MenuItem>
                    </Select>
                  </Grid>
                  {/* Department */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Department
                    </Typography>
                    <Select
                      fullWidth
                      multiple
                      value={department}
                      onChange={(e) => setDepartment(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="marketing">Marketing</MenuItem>
                      <MenuItem value="sales">Sales</MenuItem>
                      <MenuItem value="hr">Human Resources</MenuItem>
                    </Select>
                  </Grid>
                  {/* Designation */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Designation
                    </Typography>
                    <Select
                      fullWidth
                      multiple
                      value={designation}
                      onChange={(e) => setDesignation(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="trainee">Trainee</MenuItem>
                      <MenuItem value="senior">Senior</MenuItem>
                      <MenuItem value="manager">Manager</MenuItem>
                    </Select>
                  </Grid>
                  {/* Role */}
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1" gutterBottom style={{ color: "black" }}>
                      Role
                    </Typography>
                    <Select
                      fullWidth
                      multiple
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                      displayEmpty
                      sx={{
                        border: "1px solid gray",
                        "& .MuiOutlinedInput-root": {
                          "&:hover fieldset": { borderColor: "black" },
                          "&.Mui-focused fieldset": { borderColor: "black" },
                        },
                        "& .MuiSelect-select": { color: "black" },
                      }}
                    >
                      <MenuItem value="admin">App Administrator</MenuItem>
                      <MenuItem value="employee">Employee</MenuItem>
                      <MenuItem value="manager">Manager</MenuItem>
                    </Select>
                  </Grid>
                </Grid>
                <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                  <Button variant="contained" color="primary" onClick={SaveDate} sx={{backgroundColor:"#2196f3","&:hover": { backgroundColor: "orange" },}}>
                    Save
                  </Button>
                  <Button color="primary" onClick={handleClose} sx={{ ml: 2,color:"grey" }}>
                    Cancel
                  </Button>
                </Box>
              </Box>
            </Dialog>


          </React.Fragment>
        </ListItemText>
        <Divider />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ListItemText
              style={{ background: "white", margin: 0, maxWidth: "100%" }}
            >
              <ThemeProvider theme={getTheme()}>
                <Box
                  sx={{
                    maxWidth: "100%",
                  }}
                >
                  <MUIDataTable
                    title={
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: "1.5rem",
                          color: "#333",
                        }}
                      >
                        Leave Type Settings
                      </span>
                    }
                    data={leadSource}
                    columns={columns}
                    options={options}
                  />
                </Box>
              </ThemeProvider>
            </ListItemText>
          </Grid>
        </Grid>
      </List>
    </>
  );
}

export default LeaveType;
